import home from "./en/home";
import settings from "./en/settings";
import HomePage from "./en/HomePage";
import MinLivesStilHeader from "./en/MinLivesStilHeader";
import WelcomePage from "./en/WelcomePage";
import LoginPage from "./en/LoginPage";
import goals from "./en/goals";
import navigation from "./en/navigation";

export default {
  home: home,
  settings: settings,
  HomePage: HomePage,
  MinLivesStilHeader: MinLivesStilHeader,
  WelcomePage: WelcomePage,
  LoginPage: LoginPage,
  goals: goals,
  navigation: navigation,
  welcome: "Welcome! Great that you're going to try the Bwell method. Good luck!",
  start: "Get started",
  emailLabel: "Email:",
  passwordLabel: "Password:",
  login: "Log in",
  emailRequired: "Please enter your email.",
  emailInvalid: "Invalid email format",
  passwordRequired: "Please enter your password.",
  invalidCredentialsTitle: "Invalid login credentials",
  invalidCredentialsMessage: "No user found with those credentials.",
  noInternetTitle: "No internet connection",
  noInternetMessage: "It seems you don't have an internet connection.",
  serverErrorTitle: "Could not connect to server",
  serverErrorMessage: "Check your internet connection and try again later.",
  unknownErrorTitle: "An unknown error occurred",
  unknownErrorMessage: "Try again later. Contact support if the error persists.",
  privacyPolicy: "Read our privacy policy",
  forgotPassword: "Forgot password?",
  PasswordReset: {
    forgotTitle: "Reset password",
    forgotDescription: "Enter your email address and we will send you a secure link to choose a new password.",
    sendLink: "Send reset link",
    emailSent: "If an account exists for that email address, we have sent a reset link. Please also check your spam folder.",
    resetTitle: "Choose a new password",
    resetDescription: "Enter the email address for your account and choose a new password.",
    newPassword: "New password:",
    confirmPassword: "Confirm new password:",
    passwordPlaceholder: "At least 8 characters",
    confirmPasswordPlaceholder: "Repeat the password",
    passwordRequired: "Please enter a new password.",
    passwordLength: "The password must contain at least 8 characters.",
    confirmationRequired: "Please confirm your new password.",
    passwordMismatch: "The passwords do not match.",
    savePassword: "Save new password",
    resetSuccess: "Your password has been changed. You can now log in with your new password.",
    loginWithNewPassword: "Go to login",
    invalidOrExpired: "The password reset link is invalid or has expired.",
    requestNewLink: "Request a new link",
    requestError: "Something went wrong. Check your connection and try again.",
    backToLogin: "Back to login",
  },
  workMessage1: "Bwell gives you as an employee a personal lifestyle plan.",
  workMessage2: "And helps you decide how you want your physical, mental, and social life to be going forward. Things that are important to feel well!",
  featureNotAvailable: "This feature is not available in this test version."
};
